import { generateMedia } from 'styled-media-query';

export default generateMedia({
  xs: '0px',
  sm: '600px',
  md: '900px',
  lg: '1200px',
  xl: '1440px',
});
